export const USER_ALREADY_EXISTS = 1004 as const;
export const USER_NOT_EXISTS = 1001 as const;
export const LOGIN_OK = 1002 as const;
